import { bbox } from "@turf/turf";

export const zoomToSelection = (
  geometry: undefined | GeoJSON.Geometry | GeoJSON.GeometryCollection,
  googleMap: google.maps.Map | null
) => {
  // selection.geometry should always come through from a list selection but not from a map selection
  // zoomToSelection should not be called from a map click
  if (!geometry || !googleMap) {
    return;
  }

  const box = bbox(geometry);

  googleMap?.fitBounds({
    north: box[3],
    south: box[1],
    east: box[2],
    west: box[0],
  });
};
